export enum EType {
  DROPSHIPPING_INTERNATIONAL = 'DROPPSHIPPING_INTERNACIONAL',
  INFO_PRODUCT = 'INFO_PRODUCT',
  TRADITIONAL_ECOMMERCE = 'TRADITIONAL_ECOMMERCE',
  DNVB = 'DNVB',
  ENCAPSULATED = 'ENCAPSULATED',
}
